import React, {useEffect} from 'react'
import {ContainerLogin} from './styles'
import {ImageLoginPage} from "../Login/styles";
import CardNovaSenha from '../../components/CardNovaSenha';
import {useCustomizacao} from '../../Customizacao';


const NovaSenhaPage: React.FC = () => {

  const {setExibirMenu} = useCustomizacao()

  useEffect(() => {
    setExibirMenu(false);
    return () => {
      setExibirMenu(true);
    }
  }, [])

  return (
    <>
      <ContainerLogin>
        <ImageLoginPage/>
        <CardNovaSenha/>
      </ContainerLogin>
    </>
  )
}

export default NovaSenhaPage
